"use client";

import { useState, useMemo } from "react";

const API_BASE = process.env.NEXT_PUBLIC_API_URL || "";

interface AvatarProps {
  src?: string | null;
  name?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  className?: string;
  style?: React.CSSProperties;
}

const sizeMap = {
  xs: "w-5 h-5 text-[10px]",
  sm: "w-6 h-6 text-xs",
  md: "w-8 h-8 text-sm",
  lg: "w-10 h-10 text-base",
  xl: "w-16 h-16 text-xl",
};

export function Avatar({ src, name = "?", size = "md", className = "", style }: AvatarProps) {
  const [imageError, setImageError] = useState(false);
  const letter = name.charAt(0).toUpperCase();
  const sizeClass = sizeMap[size];

  // 使用 useMemo 固定时间戳，只在 src 变化时更新
  const fullSrc = useMemo(() => {
    if (!src) return null;
    if (src.startsWith("http")) return src;
    return `${API_BASE}${src}`;
  }, [src]);

  if (src && !imageError) {
    return (
      <div
        className={`${sizeClass} rounded-full overflow-hidden flex-shrink-0 ${className}`}
        style={style}
      >
        <img
          src={fullSrc || ""}
          alt={name}
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full flex-shrink-0 flex items-center justify-center font-medium ${className}`}
      style={style}
    >
      {letter}
    </div>
  );
}
